import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'



const tabSimulacaoFinanceiraFormList = ( linhaFormList, tabClienteFormList, formListRadioGroup, jsonAcessoCliente ) => {

    const tabSimulacaoFinanceiraFormListAux = []

    let cont = HARDCODE.codePoint_a

    if (!jsonAcessoCliente.acessoCliente && tabClienteFormList !== LABEL.tabClienteFormListRelatorio) {

        tabSimulacaoFinanceiraFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabSimulacaoFinanceiraSimulacao,
        )

        if (
                linhaFormList.exibirMapaFinanceiro === "S" &&
                linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "N"
        ) {

            tabSimulacaoFinanceiraFormListAux.push(
                String.fromCodePoint(cont++) + ') ' + LABEL.tabSimulacaoFinanceiraMapaFinanceiro,
            )
        }
    }

    if (
            (!jsonAcessoCliente.acessoCliente &&
                (
                    formListRadioGroup === HARDCODE.formListAprofundamento ||
                    linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "S" ||
                    tabClienteFormList === LABEL.tabClienteFormListRelatorio
                )
             ) ||
            (
                jsonAcessoCliente.acessoCliente &&
                jsonAcessoCliente.disponibilizarRelatorioSimulacaoFinanceira
            )
    ) {

        tabSimulacaoFinanceiraFormListAux.push(
            String.fromCodePoint(cont++) + ') ' + LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoCliente,
        )
    }

    if (!jsonAcessoCliente.acessoCliente) {

        if (linhaFormList.reportPrimeiraReuniaoInvestimentoSeguroVida === "S") {

            tabSimulacaoFinanceiraFormListAux.push(
                String.fromCodePoint(cont++) + ') ' + LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoInvestimento,
                String.fromCodePoint(cont++) + ') ' + LABEL.tabSimulacaoFinanceiraReportPrimeiraReuniaoSeguroVida,
            )
        }
    }

    return tabSimulacaoFinanceiraFormListAux
}

export default tabSimulacaoFinanceiraFormList